import { useDialog } from '@dni-hooks/useDialog'
import { Dialog } from '@mui/material'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'

export const DIALOG_GIFT_NOT_ENOUGH = 'DIALOG_GIFT_NOT_ENOUGH'

export interface DialogGiftNotEnoughProps {
  onSubmit?: () => void
}

export const DialogGiftNotEnough = () => {
  const { open, closeDialog, onSubmit } = useDialog<DialogGiftNotEnoughProps>(DIALOG_GIFT_NOT_ENOUGH)

  const handleSubmit = () => {
    onSubmit?.()
    closeDialog()
  }

  return (
    <Dialog disablePortal open={open} onClose={closeDialog} PaperProps={{ sx: { borderRadius: '8px', width: 320 } }}>
      <DialogHeader title="部分贈品缺貨" />
      <Box px={4}>
        <Text>部分贈品庫存不足，敬請見諒</Text>
      </Box>
      <HStack p={4} gap={2}>
        <Box flex={1}>
          <Button variant="outlined" onClick={closeDialog} fullWidth>
            取消
          </Button>
        </Box>
        <Box flex={1}>
          <Button onClick={handleSubmit} fullWidth>
            繼續結帳
          </Button>
        </Box>
      </HStack>
    </Dialog>
  )
}
